import {useQuery} from "@tanstack/react-query";
import {readProductGroupSelectBoxIn} from "../../../../../api/product/ProductInApi";

export const useReadProductGroupSelectBoxIn = () => {
    const {data} = useQuery({
        queryKey: ["readProductGroupSelectBoxIn"],
        queryFn: async () => await readProductGroupSelectBoxIn(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
